import { Link } from "react-router-dom";
import styled from "styled-components";

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 0.8em;
  font-family: Lexend Deca, cursive;
  color: blue;

  cursor: pointer;
`;

export default StyledLink;
